import * as types from './addPageActionTypes';

const initialState = {
    dialogVisible: false,
    horStep: 1,
    vertStep: 1,
    brokerID: 0,
    brokerName: '',
    purchaseOrderTypeID: 0,
    purchaseOrderTypeName: '',
    contractDate: '',
    vendorID: 0,
    vendorName: 0,
    harvestYear: '',
    unitOfMeasurementID: 0,
    unitOfMeasurementName: '',
    transportTypeID: 0,
    transportTypeName: '',
    certificateInfo: {
        number: '',
        validUntil: ''
    },
    remark: '',
    selectedFreeClauses: [],
    productID: 0,
    fromDate: '',
    toDate: '',
    quantity: '',
    unitPrice100Kg: '',
    transportPrice100Kg: '',
    purchaseOrderLines: [],
    purchaseOrderlineID: 1,
    // purchaseOrders: [],
    externalReferenceCalculated: false,
    externalReferenceID: 1,
    externalReference: '',
    contractPrice: '',
    overdelivery: '',
    validUntillDate: '',
    vendorTypeID: 0,
    vendorTypeName: '',
    editmode: false,
    editid: 0,
    editcontractmode: false,
    editcontractid: 0,
    editref: false,
    dataArea: '',
    priceSchemeDialogVisible: false
};

export default function addPage(state = initialState, action) {
    switch (action.type) {
        case types.SAVE_BROKER:
            if (state.brokerID !== action.id) {
                return Object.assign({}, state, { brokerID: action.id, brokerName: action.name });
            }
            return state;
        case types.SAVE_TYPEOFCONTRACT:
            if (state.purchaseOrderTypeID !== action.id) {
                return Object.assign({}, state, { purchaseOrderTypeID: action.id, purchaseOrderTypeName: action.name });
            }
            return state;
        case types.SAVE_DATEOFCONTRACT:
            if (state.contractDate !== action.date) {
                return Object.assign({}, state, { contractDate: action.date });
            }
            return state;
        case types.SAVE_SUPPLIERTYPE:
            if (state.vendorTypeID !== action.id) {
                return Object.assign({}, state, { vendorTypeID: action.id, vendorTypeName: action.name });
            }
            return state;
        case types.SAVE_SUPPLIER:
            if (state.vendorID !== action.id) {
                return Object.assign({}, state, { vendorID: action.id, vendorName: action.name });
            }
            return state;
        case types.SAVE_YEAR:
            if (state.harvestYear !== action.year) {
                return Object.assign({}, state, { harvestYear: action.year });
            }
            return state;
        case types.SAVE_UNITS:
            if (state.unitOfMeasurementID !== action.id) {
                return Object.assign({}, state, { unitOfMeasurementID: action.id, unitOfMeasurementName: action.name });
            }
            return state;
        case types.SAVE_TRANSPORTTYPE:
            if (state.transportTypeID !== action.id) {
                return Object.assign({}, state, { transportTypeID: action.id, transportTypeName: action.name });
            }
            return state;
        case types.SAVE_REMARK:
            if (state.remark !== action.remark) {
                return Object.assign({}, state, { remark: action.remark });
            }
            return state;
        case types.SAVE_CERTINFO:
            if (state.certificateInfo !== action.info) {
                return Object.assign({}, state, { certificateInfo: action.info });
            }
            return state;
        case types.SAVE_SELECTEDFREECLAUSES:
            if (state.selectedFreeClauses !== action.selectedFreeClauses) {
                return Object.assign({}, state, { selectedFreeClauses: action.selectedFreeClauses });
            }
            return state;
        case types.SET_VERTSTEP:
            if (state.vertStep !== action.step) {
                return Object.assign({}, state, { vertStep: action.step });
            }
            return state;
        case types.SET_HORSTEP:
            if (state.horStep !== action.step) {
                return Object.assign({}, state, { horStep: action.step });
            }
            return state;
        case types.SET_PRODUCT:
            if (state.productID !== action.id) {
                return Object.assign({}, state, { productID: action.id });
            }
            return state;
        case types.SET_FROMDATE:
            if (state.fromDate !== action.fromDate) {
                return Object.assign({}, state, { fromDate: action.fromDate });
            }
            return state;
        case types.SET_TODATE:
            if (state.toDate !== action.toDate) {
                return Object.assign({}, state, { toDate: action.toDate });
            }
            return state;
        case types.SET_QUANTITY:
            if (state.quantity !== action.quantity) {
                return Object.assign({}, state, { quantity: action.quantity });
            }
            return state;
        case types.SET_PRICE:
            //console.log('Updating SET_PRICE: ' + action.price);
            if (state.unitPrice100Kg !== action.price) {
                return Object.assign({}, state, { unitPrice100Kg: action.price });
            }
            return state;
        case types.SET_TRANSP:
            if (state.transportPrice100Kg !== action.transp) {
                return Object.assign({}, state, { transportPrice100Kg: action.transp });
            }
            return state;
        case types.ADD_PRODUCTDATA:
            return {
                ...state,
                purchaseOrderLines: [...state.purchaseOrderLines, action.data]
            }
        case types.REMOVE_PRODUCTDATA:
            var array = [...state.purchaseOrderLines];
            var index = array.map(x => {
                return x.id;
            }).indexOf(action.id);
            array.splice(index, 1);
            if (state.purchaseOrderLines !== array) {
                return Object.assign({}, state, { purchaseOrderLines: array });
            }
            return state;
        case types.EDIT_PRODUCTDATA:
            var array = [...state.purchaseOrderLines];

            var index = array.map(x => {
                return x.id;
            }).indexOf(action.data.id);

            var newArr = array.splice(index, 1, action.data)

            if (state.purchaseOrderLines !== array) {
                return Object.assign({}, state, { purchaseOrderLines: array });
            }
            return state;
        case types.SET_NEWID:
            if (state.purchaseOrderLineID !== action.id) {
                return Object.assign({}, state, { purchaseOrderLineID: action.id });
            }
            return state;
        case types.SET_DIALOGSTATE:
            if (state.dialogVisible !== action.visible) {
                return Object.assign({}, state, { dialogVisible: action.visible });
            }
            return state;
        case types.ADD_CONTRACT:
            return {
                ...state,
                purchaseOrders: [...state.purchaseOrders, action.data]
            }
        case types.SET_DETAILUOM:
            var elements = [];
            for (var i = 0; i < state.purchaseOrderLines.length; i++) {
                state.purchaseOrderLines[i].unitOfMeasurementID = action.id;
                elements.push(state.purchaseOrderLines[i]);
            }
            return {
                ...state,
                purchaseOrderLines: elements
            }
        case types.RESET_FORM:
            return Object.assign({}, state, {
                dialogVisible: false,
                horStep: 1,
                vertStep: 1,
                purchaseOrderTypeID: 0,
                contractDate: '',
                vendorID: 0,
                harvestYear: '',
                unitOfMeasurementID: 0,
                transportTypeID: 0,
                certificateInfo: {
                    number: '',
                    validUntil: ''
                },
                remark: '',
                productID: 0,
                fromDate: '',
                toDate: '',
                quantity: '',
                unitPrice100Kg: '',
                transportPrice100Kg: '',
                purchaseOrderLines: [],
                purchaseOrderLineID: 1,
                contractPrice: '',
                overdelivery: '',
                brokerID: 0,
                externalReferenceCalculated: false,
                validUntillDate: '',
                vendorTypeID: 0,
                editmode: false,
                editid: 0,
                deleteid: 0,
                editcontractmode: false,
                selectedFreeClauses: [],
                editcontractid: 0,
                editref: false,
                dataArea: '',
                brokerName:'',
                purchaseOrderTypeName:'',               
                vendorTypeName:'',
                vendorName:'',
                unitOfMeasurementName:'',
                transportTypeName:''
            });
        case types.SET_EXTERNALREFID:
            if (state.externalReferenceID !== action.id) {
                return Object.assign({}, state, { externalReferenceID: action.id });
            }
            return state;
        case types.SET_EXTERNALREFCALCULATED:
            if (state.externalReferenceID !== action.externalReferenceCalculated) {
                return Object.assign({}, state, { externalReferenceCalculated: action.externalReferenceCalculated });
            }
            return state;
        case types.SET_EXTERNALREF:
            if (state.externalReference !== action.externalReference) {
                return Object.assign({}, state, { externalReference: action.externalReference });
            }
            return state;
        case types.SET_CONTRACTPRICE:
            if (state.contractPrice !== action.price) {
                return Object.assign({}, state, { contractPrice: action.price });
            }
            return state;
        case types.SET_OVERDELIVERY:
            if (state.overdelivery !== action.value) {
                return Object.assign({}, state, { overdelivery: action.value });
            }
            return state;
        case types.SET_VALIDUNTILLDATE:
            if (state.validUntillDate !== action.date) {
                return Object.assign({}, state, { validUntillDate: action.date });
            }
        case types.SET_EDITMODE:
            if (state.editmode !== action.value) {
                return Object.assign({}, state, { editmode: action.value });
            }
            return state;
        case types.SET_EDITID:
            if (state.editid !== action.id) {
                return Object.assign({}, state, { editid: action.id });
            }
            return state;
        case types.SET_DELETED:
            if (state.deleteid !== action.id) {
                return Object.assign({}, state, { deleteid: action.id });
            }
            return state;
        case types.SET_EDITCONTRACTMODE:
            if (state.editcontractmode !== action.data) {
                return Object.assign({}, state, { editcontractmode: action.data });
            }
            return state;
        case types.SET_EDITCONTRACTID:
            if (state.editcontractid !== action.id) {
                return Object.assign({}, state, { editcontractid: action.id });
            }
            return state;
        case types.EDITCONTRACT:
            if (state.deleteid !== action.id) {
                return Object.assign({}, state, { deleteid: action.id });
            }
            return state;
        case types.SET_EDITCONTRACTDATA:
            return Object.assign({}, state, {
                externalReference: action.data.ExternalReference,
                contractDate: action.data.ContractDate,
                purchaseOrderTypeID: action.data.PurchaseOrderTypeID,
                unitOfMeasurementID: action.data.UnitOfMeasurementID,
                vendorID: action.data.VendorID,
                vendorTypeID: action.data.VendorTypeID,
                transportTypeID: action.data.TransportTypeID,
                transportPrice100Kg: String(action.data.TransportPrice100Kg),
                harvestYear: action.data.HarvestYear,
                brokerID: action.data.BrokerID,
                certificateInfo: action.data.CertificateInfo,
                remark: action.data.Remark,
                html: action.data.html,
                validUntillDate: action.data.ValidUntil,
            });
        case types.SET_PURCHASEORDERLINES:
            return Object.assign({}, state, {
                purchaseOrderLines: action.data,
            });
        case types.EDIT_REF:
            if (state.editref !== action.editref) {
                return Object.assign({}, state, { editref: action.editref });
            }
            return state;
        case types.SET_DATAAREA:
            if (state.dataArea !== action.data) {
                return Object.assign({}, state, { dataArea: action.data });
            }
            return state;
        case types.SET_PRICESCHEMEDIALOGVISIBLE:
            //console.log('Updating SET_PRICESCHEMEDIALOGVISIBLE: ' + action.visible);
            if (state.priceSchemeDialogVisible !== action.visible) {
                return Object.assign({}, state, { priceSchemeDialogVisible: action.visible });
            }
            return state;
        default:
            return state;
    }
}